import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type ButtonType = {
    text: string,
    type?: keyof typeof styles,
    onClick?: () => void,
    disabled?: boolean,
    loading?: boolean
}

const styles = {
    default: 'btn w-full bg-slate-150 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80 dark:bg-navy-500 dark:text-navy-50 dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90',
    defaultSmall: 'btn h-6 px-3 text-xs w-full bg-slate-150 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80 dark:bg-navy-500 dark:text-navy-50 dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90',
    primary: 'btn w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90',
    primarySmall: 'btn h-6 px-3 text-xs w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90',
    secondary: 'btn w-full bg-secondary font-medium text-white hover:bg-secondary-focus focus:bg-secondary-focus active:bg-secondary-focus/90',
    info: 'btn w-full bg-info font-medium text-white hover:bg-info-focus focus:bg-info-focus active:bg-info-focus/90',
    infoSmall: 'btn h-6 px-3 text-xs w-full bg-info font-medium text-white hover:bg-info-focus focus:bg-info-focus active:bg-info-focus/90',
    success: 'btn w-full bg-success font-medium text-white hover:bg-success-focus focus:bg-success-focus active:bg-success-focus/90',
    successSmall: 'btn h-6 px-3 text-xs w-full bg-success font-medium text-white hover:bg-success-focus focus:bg-success-focus active:bg-success-focus/90',
    warning: 'btn w-full bg-warning font-medium text-white hover:bg-warning-focus focus:bg-warning-focus active:bg-warning-focus/90',
    warningSmall: 'btn h-6 px-3 text-xs w-full bg-warning font-medium text-white hover:bg-warning-focus focus:bg-warning-focus active:bg-warning-focus/90',
    error: 'btn w-full bg-error font-medium text-white hover:bg-error-focus focus:bg-error-focus active:bg-error-focus/90',
    errorSmall: 'btn h-6 px-3 text-xs w-full bg-error font-medium text-white hover:bg-error-focus focus:bg-error-focus active:bg-error-focus/90',
    infoLight: 'btn w-full bg-info/10 font-medium text-info hover:bg-info/20 focus:bg-info/20 active:bg-info/25',
    errorOutline: 'btn border border-error font-medium text-error hover:bg-error hover:text-white focus:bg-error focus:text-white active:bg-error/90',
    infoOutlineSmall: 'btn h-6 px-3 text-xs w-full border border-info font-medium text-info hover:bg-info hover:text-white focus:bg-info focus:text-white active:bg-info/90',
    defaultOutlineSmall: 'btn h-6 px-3 text-xs w-full border border-slate-300 font-medium text-slate-800 hover:bg-slate-150 focus:bg-slate-150 active:bg-slate-150/80 dark:border-navy-450 dark:text-navy-50 dark:hover:bg-navy-500 dark:focus:bg-navy-500 dark:active:bg-navy-500/90',
}

const Button = ({text, type = 'default', onClick, disabled = false, loading = false}: ButtonType) => {

    return <button onClick={onClick} className={loading ? styles['default'] : styles[type]} disabled={disabled || loading}>
        {
            loading && <Spin style={{opacity: '0.5'}} indicator={
                <LoadingOutlined spin/>
            }/>
        }
        {
            !loading && text
        }
    </button>

}

export default Button;
